import ProjectService from "../ProjectService";

describe("ProjectService model", () => {
  test("hasMany relations", () => {
    expect(
      ProjectService.hasMany.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
